import React, {useCallback, useEffect} from 'react';
import {observer} from 'mobx-react';
import {SearchResultComponent} from './search-result/search-result.component';
import {SearchInputMobileComponent} from "./search-input/search-input-mobile/search-input-mobile.component";
import {SearchInputPCComponent} from "./search-input/search-input-pc/search-input-pc.component";
import {GameSearchBox} from "./boxes/game-search-box/game-search.box";
import {CyClass} from '../../../common/cy-classes';
import classNames from 'classnames';
import {ComponentServicesPick} from "../../services/component-services-pick";
import {useServices} from "../../react-hooks/use-services.hook";
import {withServices} from "../../react-hooks/with-services";

interface GameSearchComponentProps extends ComponentServicesPick<'gameSearch'> {
  className?: string;
}

const ComponentBody: React.FC<GameSearchComponentProps> = observer((props) => {
    const services = useServices();
    const _onUpdate = useCallback(() => {
        props.gameSearch.searchResultComponentRef.current?.scrollTo(0, 0);
    }, [props.gameSearch])

    const _renderSearchInput = () => {
        return services.device.isMobile ? <SearchInputMobileComponent /> : <SearchInputPCComponent/>;
    }

    useEffect(() => {
        props.gameSearch.searchInputRef?.current?.addEventListener("input", _onUpdate);

        return () => {
            props.gameSearch.searchInputRef?.current?.removeEventListener("input", _onUpdate);
        }
    }, [props.gameSearch, _onUpdate]);

    return (
        <GameSearchBox className={classNames(CyClass('cy-game-search-box'), props.className)}
                       open={props.gameSearch.isSearchBoxOpened}
                       ref={props.gameSearch.searchComponentRef}>
            {_renderSearchInput()}
            <SearchResultComponent/>
        </GameSearchBox>
    );
})

export const GameSearchComponent = withServices(ComponentBody, ['gameSearch']);